import { Component } from '@angular/core';
import { AdminMenuComponent } from "./AdminMenuComponent";
@Component({
	selector: 'app-admin-submenu',
	templateUrl: './AdminSubmenuComponent.html'
})
export class AdminSubmenuComponent extends AdminMenuComponent {
}
